import { render, staticRenderFns } from "./ResendMailModal.vue?vue&type=template&id=00365954&scoped=true&"
import script from "./ResendMailModal.vue?vue&type=script&lang=js&"
export * from "./ResendMailModal.vue?vue&type=script&lang=js&"
import style0 from "./ResendMailModal.vue?vue&type=style&index=0&id=00365954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00365954",
  null
  
)

export default component.exports